import * as React from 'react';

export interface IUseOnValueChange {
  resetValidation(): void;

  setSuggestValue(value: string): void;

  getSuggestions(value: string): void;
}

export const useOnValueChange = ({ getSuggestions, setSuggestValue, resetValidation }: IUseOnValueChange) => {
  return React.useCallback(
    (value: string) => {
      resetValidation();
      setSuggestValue(value);
      getSuggestions(value);
    },
    [getSuggestions, setSuggestValue, resetValidation],
  );
};
